import React from "react";
import { Nav } from "./components/Nav";
import { HeroBillboard } from "./components/HeroBillboard";
import { FilmRow } from "./components/FilmRow";
import { TopTenRow } from "./components/TopTenRow";
import { NoTellSlider } from "./components/NoTellSlider";
import { WhyBrandhero } from "./components/WhyBrandhero";
import { LogoMarquee } from "./components/LogoMarquee";
import { FilmStripProcess } from "./components/FilmStripProcess";
import { PlanPicker } from "./components/PlanPicker";
import { FaqAccordion } from "./components/FaqAccordion";
import { SignupCta } from "./components/SignupCta";
import { Footer } from "./components/Footer";
import { adFilms, hooks, series, trailers } from "./data/films";
interface AppProps {
  heroAlign?: "left" | "center";
  hoverExpand?: boolean;
  rowSpacing?: "airy" | "compact";
}
export function App({
  heroAlign = "left",
  hoverExpand = true,
  rowSpacing = "airy"
}: AppProps) {
  const rowGap = rowSpacing === "airy" ? "gap-20 md:gap-32" : "gap-12 md:gap-16";
  return <div className="min-h-screen w-full overflow-x-clip bg-ink text-body" data-id="element-0" data-mp="3ij64a9st9l7v">
      {/* Brandhero frame: hairline rails along the content edges */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-y-0 left-1/2 z-[1] hidden w-full max-w-[calc(1320px+var(--gutter)*2)] -translate-x-1/2 px-[var(--gutter)] md:block" data-id="element-1" data-mp="3mj6lu3b7icj5">
        <div className="h-full w-full border-x border-white/[0.07]" data-id="element-2" data-mp="2zld2xbxu5jcl" />
      </div>
      <Nav data-id="element-3" data-mp="2zng2amkvootz" />
      <main data-id="element-4" data-mp="33mf2xuzktzfm">
        <HeroBillboard align={heroAlign} data-id="element-5" data-mp="33m5ck6amdq9e" />
        <div id="films" className={`relative z-10 -mt-24 flex scroll-mt-0 flex-col pb-24 md:pb-32 ${rowGap}`} data-id="element-6" data-mp="33n6w6z5pbl2q">
          <FilmRow title="Ad films & TVCs" aspect="16:9" films={adFilms} hoverExpand={hoverExpand} data-id="element-7" data-mp="38nunzn1r85y0" />
          <FilmRow title="Hooks, reels & social" subtitle="MADE FOR THE FIRST 3 SECONDS" aspect="9:16" films={hooks} data-id="element-8" data-mp="3dirwmsv4gdad" />
          <TopTenRow data-id="element-9" data-mp="sunas11342df" />
          <FilmRow title="Binge-worthy series & microdramas" aspect="2:3" films={series} data-id="element-10" data-mp="su42lc18kscl" />
          <FilmRow title="Coming soon — trailers & teasers" aspect="2.39:1" films={trailers} data-id="element-11" data-mp="35yq6nee9s31" />
        </div>
        <NoTellSlider data-id="element-12" data-mp="3udazyhcy738x" />
        <WhyBrandhero data-id="element-13" data-mp="3ubzumd3utnfp" />
        <LogoMarquee data-id="element-14" data-mp="3ucj8niqdvrog" />
        <FilmStripProcess data-id="element-15" data-mp="d4nwdiwxho3g" />
        <PlanPicker data-id="element-16" data-mp="d4xobc1ja5bs" />
        <FaqAccordion data-id="element-17" data-mp="d3cw3t2oyyh3" />
        <SignupCta data-id="element-18" data-mp="d2l9v8uzid3h" />
      </main>
      <Footer data-id="element-19" data-mp="85uk1ttdo34v" />
    </div>;
}